<template>
  <v-ons-page>
    <v-ons-row style="margin-top: 100px; text-align: center;">
      <v-ons-col>
        <p>Welcome home.</p>
      </v-ons-col>
    </v-ons-row>
  </v-ons-page>
</template>

<script>
  export default {
  }
</script>



// WEBPACK FOOTER //
// homePage.vue?9ce63776